import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "total", "remaining", "input" ]

  connect() {
    this.updateTotal()
  }

  updateTotal() {
    let total = this.calculateTotal()
    let remaining = (100 - total).toFixed(2)
    this.totalTarget.innerText = total
    this.remainingTarget.innerText = remaining

    if (remaining < 0) {
      this.remainingTarget.classList.add('text-red-500')
    } else {
      this.remainingTarget.classList.remove('text-red-500')
    }
  }

  calculateTotal(){
    let total = 0

    this.inputTargets.forEach((input) => {
      let value = parseFloat(input.value, 10)

      if (!isNaN(value)) {
        total += value
      }
    })

    return total.toFixed(2)
  }
}
